/**
 * ContentBlock types for structured assistant message content.
 * Used to render different types of content within message bubbles.
 */

export interface ImageItem {
    url: string;
    alt?: string;
    width?: number;
    height?: number;
}

export interface ImageQuery {
    query: string;
    limit?: number;
}

export interface TextContentBlock {
    type: "text";
    markdown: string;
}

export interface ImageGroupContentBlock {
    type: "image_group";
    layout?: "carousel" | "single";
    /** Pre-resolved images (already have URLs) */
    images?: ImageItem[];
    /** Queries to resolve dynamically (fetched at render time) */
    queries?: ImageQuery[];
    caption?: string;
}

export type ContentBlock = TextContentBlock | ImageGroupContentBlock;

/**
 * Type guard to check if a ContentBlock is a text block
 */
export function isTextBlock(block: ContentBlock): block is TextContentBlock {
    return block.type === "text";
}

/**
 * Type guard to check if a ContentBlock is an image group block
 */
export function isImageGroupBlock(block: ContentBlock): block is ImageGroupContentBlock {
    return block.type === "image_group";
}
